import getJSON from "@/js/libs/getJSON";
import summary from "@/js/parts/checkout/refreshSummary";
import isInCart from "@/js/libs/isInCart";
import getParents from "@/js/libs/getParents";

let APP = window.APP || {};
const addAction = "commerce/cart/update-cart";
const removeAction = "commerce/cart/update-cart";

// One big init function, assume polyfils and docready when this is called:
export default function (element, onRefresh) {
  let parents = getParents(element, ".Formgroup");

  let purchasableId = element.getAttribute("value");

  if (!purchasableId) {
    console.warn("no purchasable ID set, cannot add or remove");
    return;
  }

  let options = {};

  let optionAttribute = element.getAttribute("data-options");

  if (optionAttribute) {
    optionAttribute.split("|").forEach((part) => {
      let keyValue = part.split(":");
      options[keyValue[0]] = keyValue[1];
    });
  } else {
    options = false;
  }

  let lineItem = isInCart({ lineItems: APP.lineItems }, purchasableId, options);

  if (lineItem) {
    element.checked = true;
  }

  const states = {
    loading: function () {
      summary.loading();
      if (parents.length) {
        parents[0].style.opacity = 0.5;
      }
    },
    refresh: function (json) {
      if (typeof onRefresh === "function") {
        onRefresh(json);
      }

      summary.refresh(function () {
        if (parents.length) {
          parents[0].style.opacity = 1;
        }
      });
    },
    ready: function () {
      summary.ready();
      if (parents.length) {
        parents[0].style.opacity = 1;
      }
    },
  };

  const add = function (_qty) {
    // Almost always 1
    let formData = new FormData();
    formData.set("purchasableId", purchasableId);
    formData.set("qty", _qty ? _qty : 1);
    formData.set("action", addAction);

    if (options) {
      for (let handle in options) {
        formData.set("options[" + handle + "]", options[handle]);
      }
    }

    post(formData);
  };

  const remove = function (lineItemId) {
    let formData = new FormData();
    formData.set("action", removeAction);
    formData.set("lineItemId", lineItemId);
    post(formData);
  };

  const success = function (json) {
    APP.lineItems = json.cart.lineItems;
    states.refresh(json);
  };

  const error = function (err) {
    console.log(err);
    let data = err.response.data;
    APP.showModal(data.message);
    states.ready();
  };

  const post = function (formData) {
    states.loading();
    formData.set(APP.config.csrfName, APP.config.csrfValue);
    getJSON(window.location.href, formData, success, error);
  };

  // kick it all off:
  element.addEventListener("change", () => {
    let purchasableId = element.value;
    let lineItem = isInCart(
      { lineItems: APP.lineItems },
      purchasableId,
      options,
    );

    if (element.checked) {
      if (lineItem) {
        console.warn("Tried to add item already in cart");
      } else {
        add();
      }
    } else {
      if (lineItem) {
        remove(lineItem.id);
      } else {
        console.warn("Tried to remove item not in cart");
      }
    }
  });
}
